import { useSearchParams } from 'react-router'

export const useSearchParam = (key: string) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const setValue = (value: string | null) => {
    setSearchParams((previous) => {
      const next = new URLSearchParams(previous)
      if (value) {
        next.set(key, value)
      } else {
        next.delete(key)
      }
      return next
    })
  }

  return [searchParams.get(key), setValue] as const
}
